export default __webpack_public_path__ + "static/media/Category-20.96938031.jpg";